import Fuse from "fuse.js";
import { setFaqItemOpen } from "./_faqAccordion";

const SELECTORS = {
  SEARCH_INPUT: "search__input",
  SEARCH_BUTTON: "search__button",
  SEARCH_CLEAR: "search__clear",
  FAQ_ITEMS: "faq__item",
  FAQ_QUESTION: "faq__item-title",
  FAQ_ANSWER: "faq__item-answer",
  TABS: "tabs__item",
  TABS_ACTIVE: "tabs__item--active",
  NO_RESULTS: "faq__no-results",
};

export class FaqSearch {
  constructor() {
    this.searchInput = document.getElementById("search-input");
    this.searchButton = document.getElementById("search-button");
    this.clearButton = document.getElementById("search-clear");
    this.faqItems = document.querySelectorAll(`.${SELECTORS.FAQ_ITEMS}`);
    this.tabs = document.querySelectorAll(`.${SELECTORS.TABS}`);

    this.faqData = this.prepareFaqData();
    this.fuse = this.initializeFuse();
    this.isSearchActive = false;
    this.currentTabSection = this.getCurrentTabSection();

    this.init();
  }

  init() {
    this.setEventListeners();
    this.createNoResultsElement();
  }

  setEventListeners() {
    this.searchInput.addEventListener("input", (e) => this.handleSearch(e));
    this.clearButton.addEventListener("click", () => this.clearSearch());

    // Слушаем изменения табов
    this.tabs.forEach((tab) => {
      tab.addEventListener("click", (e) => {
        setTimeout(() => {
          this.currentTabSection = this.getCurrentTabSection();
          if (this.isSearchActive) {
            this.performSearch(this.searchInput.value);
          }
        }, 0);
      });
    });
  }

  prepareFaqData() {
    const data = [];
    this.faqItems.forEach((item, index) => {
      const question =
        item.querySelector(`.${SELECTORS.FAQ_QUESTION}`)?.textContent || "";
      const answer =
        item.querySelector(`.${SELECTORS.FAQ_ANSWER}`)?.textContent || "";
      const section = item.dataset.section || "";

      data.push({
        index,
        question: question.trim(),
        answer: answer.trim(),
        section,
        element: item,
      });
    });
    return data;
  }

  initializeFuse() {
    const options = {
      keys: [
        {
          name: "question",
          weight: 0.7,
        },
        {
          name: "answer",
          weight: 0.3,
        },
      ],
      threshold: 0.3, // Чувствительность поиска (0 = точное совпадение, 1 = любое совпадение)
      includeScore: true,
      minMatchCharLength: 2,
      ignoreLocation: true,
    };

    return new Fuse(this.faqData, options);
  }

  getCurrentTabSection() {
    const activeTab = document.querySelector(`.${SELECTORS.TABS_ACTIVE}`);
    if (activeTab && activeTab.href) {
      return activeTab.href.slice(activeTab.href.indexOf("#") + 1);
    }
    return "how-to-take"; // По умолчанию
  }

  handleSearch(event) {
    const query = event.target.value.trim();

    if (query.length === 0) {
      this.clearSearch();
      return;
    }

    // Показываем кнопку очистки и скрываем кнопку поиска
    this.showClearButton();
    this.hideSearchButton();

    if (query.length < 2) {
      return; // Не ищем, если меньше 2 символов
    }

    this.isSearchActive = true;
    this.performSearch(query);
  }

  performSearch(query) {
    const results = this.fuse.search(query);

    // Фильтруем результаты по текущему табу, если поиск активен
    const filteredResults = this.isSearchActive
      ? results.filter(
          (result) => result.item.section === this.currentTabSection,
        )
      : results;

    this.displayResults(filteredResults);
  }

  displayResults(results) {
    // Скрываем все элементы FAQ и закрываем их
    this.faqItems.forEach((item) => {
      item.style.display = "none";
      setFaqItemOpen(item, false);
    });

    if (results.length === 0) {
      this.showNoResults();
      return;
    }

    this.hideNoResults();

    // Показываем только найденные элементы
    results.forEach((result) => {
      const item = result.item.element;
      item.style.display = "block";
    });
  }

  clearSearch() {
    this.searchInput.value = "";
    this.isSearchActive = false;
    this.hideClearButton();
    this.showSearchButton();
    this.hideNoResults();

    // Закрыть все элементы
    this.faqItems.forEach((item) => {
      setFaqItemOpen(item, false);
    });

    // Показываем элементы согласно текущему табу
    this.showItemsByCurrentTab();
  }

  showItemsByCurrentTab() {
    this.faqItems.forEach((item) => {
      if (item.dataset.section === this.currentTabSection) {
        item.style.display = "block";
      } else {
        item.style.display = "none";
        // Закрыть скрытые элементы
        setFaqItemOpen(item, false);
      }
    });
  }

  showClearButton() {
    this.clearButton.style.display = "flex";
  }

  hideClearButton() {
    this.clearButton.style.display = "none";
  }

  showSearchButton() {
    this.searchButton.style.display = "flex";
  }

  hideSearchButton() {
    this.searchButton.style.display = "none";
  }

  createNoResultsElement() {
    // Проверяем, не существует ли уже элемент
    const existingElement = document.querySelector(`.${SELECTORS.NO_RESULTS}`);
    if (existingElement) {
      this.noResultsElement = existingElement;
      return;
    }

    this.noResultsElement = document.createElement("div");
    this.noResultsElement.className = SELECTORS.NO_RESULTS;
    this.noResultsElement.innerHTML = `
      <p>К сожалению, ничего не найдено</p>
    `;
    this.noResultsElement.style.display = "none";

    // Вставляем элемент после списка FAQ
    const faqList = document.querySelector(".faq__list");
    if (faqList && faqList.parentNode) {
      faqList.parentNode.insertBefore(
        this.noResultsElement,
        faqList.nextSibling,
      );
    }
  }

  showNoResults() {
    if (this.noResultsElement) {
      this.noResultsElement.style.display = "flex";
    }
  }

  hideNoResults() {
    if (this.noResultsElement) {
      this.noResultsElement.style.display = "none";
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {
  new FaqSearch();
});
